import { GetChangeQuantityFromProjectOptions } from '../analytics-context-types';
import { getModalLevel2, getPODModalTag, getPODProductTag } from './utils';

/**
 * Gets the modal and product tag to track when the quantity change on the project summary
 *
 * @param options attributes to be included in product tag and modal event tag
 * @returns
 */
export const getChangeQuantityFromProjectTag = (options: GetChangeQuantityFromProjectOptions) => {
  const changeQuantityFromProjectEvent = [
    {
      eventInfo: {
        eventName: options.initiator,
        eventAction: 'update quantity',
      },
    },
    {
      eventInfo: {
        eventName: 'product quantity',
        eventAction: options.quantity,
      },
    },
  ];

  if (options.isIncreasing !== undefined && options.selectedAction) {
    changeQuantityFromProjectEvent.push({
      eventInfo: {
        eventName: options.isIncreasing ? 'quantity increase' : 'quantity decrease',
        eventAction: options.selectedAction,
      },
    });
  }

  const { product } = getPODProductTag(options.productName, options.productID, options.productType, options.quantity);

  const level2 = getModalLevel2();

  const { modal, user } = getPODModalTag(level2, changeQuantityFromProjectEvent, options.projectID);

  const newModal = {
    ...modal,
    messages: [{ statusMessages: options.statusMessage || '' }],
  };

  return {
    product,
    modal: newModal,
    user,
  };
};
